/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * PaymentGatewayProxy.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AdminClientsGetAdminClientsParams,
  ClientDetailDto,
  CreateClientRequest,
  CreateClientResult,
  HttpValidationProblemDetails,
  PagedResultOfClientSummaryDto,
  SetClientAdyenEnvironmentRequest,
  UpdateClientRequest,
} from '.././schemas';

import { apiFetcher } from '../../http/apiFetcher';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Paginated list of partner clients.
 */
export const adminClientsGetAdminClients = (
  params?: AdminClientsGetAdminClientsParams,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<PagedResultOfClientSummaryDto>(
    { url: `/admin/clients`, method: 'GET', params, signal },
    options,
  );
};

export const getAdminClientsGetAdminClientsQueryKey = (
  params?: AdminClientsGetAdminClientsParams,
) => {
  return [`/admin/clients`, ...(params ? [params] : [])] as const;
};

export const getAdminClientsGetAdminClientsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminClientsGetAdminClients>>,
  TError = unknown,
>(
  params?: AdminClientsGetAdminClientsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminClientsGetAdminClients>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminClientsGetAdminClientsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminClientsGetAdminClients>>> = ({
    signal,
  }) => adminClientsGetAdminClients(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminClientsGetAdminClients>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminClientsGetAdminClientsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminClientsGetAdminClients>>
>;
export type AdminClientsGetAdminClientsQueryError = unknown;

export function useAdminClientsGetAdminClients<
  TData = Awaited<ReturnType<typeof adminClientsGetAdminClients>>,
  TError = unknown,
>(
  params: undefined | AdminClientsGetAdminClientsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminClientsGetAdminClients>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminClientsGetAdminClients>>,
          TError,
          Awaited<ReturnType<typeof adminClientsGetAdminClients>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminClientsGetAdminClients<
  TData = Awaited<ReturnType<typeof adminClientsGetAdminClients>>,
  TError = unknown,
>(
  params?: AdminClientsGetAdminClientsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminClientsGetAdminClients>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminClientsGetAdminClients>>,
          TError,
          Awaited<ReturnType<typeof adminClientsGetAdminClients>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminClientsGetAdminClients<
  TData = Awaited<ReturnType<typeof adminClientsGetAdminClients>>,
  TError = unknown,
>(
  params?: AdminClientsGetAdminClientsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminClientsGetAdminClients>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Paginated list of partner clients.
 */

export function useAdminClientsGetAdminClients<
  TData = Awaited<ReturnType<typeof adminClientsGetAdminClients>>,
  TError = unknown,
>(
  params?: AdminClientsGetAdminClientsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminClientsGetAdminClients>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminClientsGetAdminClientsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a new client. Returns the generated secret ONCE.
 */
export const adminClientsPostAdminClients = (
  createClientRequest: CreateClientRequest,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<CreateClientResult>(
    {
      url: `/admin/clients`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createClientRequest,
      signal,
    },
    options,
  );
};

export const getAdminClientsPostAdminClientsMutationOptions = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminClientsPostAdminClients>>,
    TError,
    { data: CreateClientRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminClientsPostAdminClients>>,
  TError,
  { data: CreateClientRequest },
  TContext
> => {
  const mutationKey = ['adminClientsPostAdminClients'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminClientsPostAdminClients>>,
    { data: CreateClientRequest }
  > = (props) => {
    const { data } = props ?? {};

    return adminClientsPostAdminClients(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminClientsPostAdminClientsMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminClientsPostAdminClients>>
>;
export type AdminClientsPostAdminClientsMutationBody = CreateClientRequest;
export type AdminClientsPostAdminClientsMutationError = HttpValidationProblemDetails;

/**
 * @summary Create a new client. Returns the generated secret ONCE.
 */
export const useAdminClientsPostAdminClients = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminClientsPostAdminClients>>,
      TError,
      { data: CreateClientRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminClientsPostAdminClients>>,
  TError,
  { data: CreateClientRequest },
  TContext
> => {
  const mutationOptions = getAdminClientsPostAdminClientsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const adminClientsGetAdminClientsIdGuid = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<ClientDetailDto>(
    { url: `/admin/clients/${id}`, method: 'GET', signal },
    options,
  );
};

export const getAdminClientsGetAdminClientsIdGuidQueryKey = (id?: string) => {
  return [`/admin/clients/${id}`] as const;
};

export const getAdminClientsGetAdminClientsIdGuidQueryOptions = <
  TData = Awaited<ReturnType<typeof adminClientsGetAdminClientsIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminClientsGetAdminClientsIdGuid>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminClientsGetAdminClientsIdGuidQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminClientsGetAdminClientsIdGuid>>> = ({
    signal,
  }) => adminClientsGetAdminClientsIdGuid(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminClientsGetAdminClientsIdGuid>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminClientsGetAdminClientsIdGuidQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminClientsGetAdminClientsIdGuid>>
>;
export type AdminClientsGetAdminClientsIdGuidQueryError = unknown;

export function useAdminClientsGetAdminClientsIdGuid<
  TData = Awaited<ReturnType<typeof adminClientsGetAdminClientsIdGuid>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminClientsGetAdminClientsIdGuid>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminClientsGetAdminClientsIdGuid>>,
          TError,
          Awaited<ReturnType<typeof adminClientsGetAdminClientsIdGuid>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminClientsGetAdminClientsIdGuid<
  TData = Awaited<ReturnType<typeof adminClientsGetAdminClientsIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminClientsGetAdminClientsIdGuid>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminClientsGetAdminClientsIdGuid>>,
          TError,
          Awaited<ReturnType<typeof adminClientsGetAdminClientsIdGuid>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminClientsGetAdminClientsIdGuid<
  TData = Awaited<ReturnType<typeof adminClientsGetAdminClientsIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminClientsGetAdminClientsIdGuid>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useAdminClientsGetAdminClientsIdGuid<
  TData = Awaited<ReturnType<typeof adminClientsGetAdminClientsIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminClientsGetAdminClientsIdGuid>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminClientsGetAdminClientsIdGuidQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const adminClientsPutAdminClientsIdGuid = (
  id: string,
  updateClientRequest: UpdateClientRequest,
  options?: SecondParameter<typeof apiFetcher>,
) => {
  return apiFetcher<ClientDetailDto>(
    {
      url: `/admin/clients/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateClientRequest,
    },
    options,
  );
};

export const getAdminClientsPutAdminClientsIdGuidMutationOptions = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminClientsPutAdminClientsIdGuid>>,
    TError,
    { id: string; data: UpdateClientRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminClientsPutAdminClientsIdGuid>>,
  TError,
  { id: string; data: UpdateClientRequest },
  TContext
> => {
  const mutationKey = ['adminClientsPutAdminClientsIdGuid'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminClientsPutAdminClientsIdGuid>>,
    { id: string; data: UpdateClientRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminClientsPutAdminClientsIdGuid(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminClientsPutAdminClientsIdGuidMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminClientsPutAdminClientsIdGuid>>
>;
export type AdminClientsPutAdminClientsIdGuidMutationBody = UpdateClientRequest;
export type AdminClientsPutAdminClientsIdGuidMutationError = HttpValidationProblemDetails;

export const useAdminClientsPutAdminClientsIdGuid = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminClientsPutAdminClientsIdGuid>>,
      TError,
      { id: string; data: UpdateClientRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminClientsPutAdminClientsIdGuid>>,
  TError,
  { id: string; data: UpdateClientRequest },
  TContext
> => {
  const mutationOptions = getAdminClientsPutAdminClientsIdGuidMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Soft-delete a client (SuperAdmin only).
 */
export const adminClientsDeleteAdminClientsIdGuid = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
) => {
  return apiFetcher<void>({ url: `/admin/clients/${id}`, method: 'DELETE' }, options);
};

export const getAdminClientsDeleteAdminClientsIdGuidMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminClientsDeleteAdminClientsIdGuid>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminClientsDeleteAdminClientsIdGuid>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminClientsDeleteAdminClientsIdGuid'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminClientsDeleteAdminClientsIdGuid>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminClientsDeleteAdminClientsIdGuid(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminClientsDeleteAdminClientsIdGuidMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminClientsDeleteAdminClientsIdGuid>>
>;

export type AdminClientsDeleteAdminClientsIdGuidMutationError = unknown;

/**
 * @summary Soft-delete a client (SuperAdmin only).
 */
export const useAdminClientsDeleteAdminClientsIdGuid = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminClientsDeleteAdminClientsIdGuid>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminClientsDeleteAdminClientsIdGuid>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminClientsDeleteAdminClientsIdGuidMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const adminClientsPostAdminClientsIdGuidSuspend = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<ClientDetailDto>(
    { url: `/admin/clients/${id}/suspend`, method: 'POST', signal },
    options,
  );
};

export const getAdminClientsPostAdminClientsIdGuidSuspendMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminClientsPostAdminClientsIdGuidSuspend>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminClientsPostAdminClientsIdGuidSuspend>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminClientsPostAdminClientsIdGuidSuspend'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminClientsPostAdminClientsIdGuidSuspend>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminClientsPostAdminClientsIdGuidSuspend(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminClientsPostAdminClientsIdGuidSuspendMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminClientsPostAdminClientsIdGuidSuspend>>
>;

export type AdminClientsPostAdminClientsIdGuidSuspendMutationError = unknown;

export const useAdminClientsPostAdminClientsIdGuidSuspend = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminClientsPostAdminClientsIdGuidSuspend>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminClientsPostAdminClientsIdGuidSuspend>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminClientsPostAdminClientsIdGuidSuspendMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const adminClientsPostAdminClientsIdGuidActivate = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<ClientDetailDto>(
    { url: `/admin/clients/${id}/activate`, method: 'POST', signal },
    options,
  );
};

export const getAdminClientsPostAdminClientsIdGuidActivateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminClientsPostAdminClientsIdGuidActivate>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminClientsPostAdminClientsIdGuidActivate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminClientsPostAdminClientsIdGuidActivate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminClientsPostAdminClientsIdGuidActivate>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminClientsPostAdminClientsIdGuidActivate(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminClientsPostAdminClientsIdGuidActivateMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminClientsPostAdminClientsIdGuidActivate>>
>;

export type AdminClientsPostAdminClientsIdGuidActivateMutationError = unknown;

export const useAdminClientsPostAdminClientsIdGuidActivate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminClientsPostAdminClientsIdGuidActivate>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminClientsPostAdminClientsIdGuidActivate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminClientsPostAdminClientsIdGuidActivateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Promote / demote between Adyen Test and Live (SuperAdmin only).
 */
export const adminClientsPutAdminClientsIdGuidAdyenEnvironment = (
  id: string,
  setClientAdyenEnvironmentRequest: SetClientAdyenEnvironmentRequest,
  options?: SecondParameter<typeof apiFetcher>,
) => {
  return apiFetcher<ClientDetailDto>(
    {
      url: `/admin/clients/${id}/adyen-environment`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: setClientAdyenEnvironmentRequest,
    },
    options,
  );
};

export const getAdminClientsPutAdminClientsIdGuidAdyenEnvironmentMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminClientsPutAdminClientsIdGuidAdyenEnvironment>>,
    TError,
    { id: string; data: SetClientAdyenEnvironmentRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminClientsPutAdminClientsIdGuidAdyenEnvironment>>,
  TError,
  { id: string; data: SetClientAdyenEnvironmentRequest },
  TContext
> => {
  const mutationKey = ['adminClientsPutAdminClientsIdGuidAdyenEnvironment'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminClientsPutAdminClientsIdGuidAdyenEnvironment>>,
    { id: string; data: SetClientAdyenEnvironmentRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminClientsPutAdminClientsIdGuidAdyenEnvironment(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminClientsPutAdminClientsIdGuidAdyenEnvironmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminClientsPutAdminClientsIdGuidAdyenEnvironment>>
>;
export type AdminClientsPutAdminClientsIdGuidAdyenEnvironmentMutationBody =
  SetClientAdyenEnvironmentRequest;
export type AdminClientsPutAdminClientsIdGuidAdyenEnvironmentMutationError = unknown;

/**
 * @summary Promote / demote between Adyen Test and Live (SuperAdmin only).
 */
export const useAdminClientsPutAdminClientsIdGuidAdyenEnvironment = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminClientsPutAdminClientsIdGuidAdyenEnvironment>>,
      TError,
      { id: string; data: SetClientAdyenEnvironmentRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminClientsPutAdminClientsIdGuidAdyenEnvironment>>,
  TError,
  { id: string; data: SetClientAdyenEnvironmentRequest },
  TContext
> => {
  const mutationOptions =
    getAdminClientsPutAdminClientsIdGuidAdyenEnvironmentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
